import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const localMethods = {

    methods: {

        async project_task_query()
        {

            let dinamic_query = {
                type:           'query',
                floor_id:       this.form_data.floor_id,
                daily_task_id:  this.form_data.task_id,
            }

            let response = await this.get(`${this.rest_api}/${JSON.stringify(dinamic_query)}`)
            if(response.status)
            {

                this.project_tasks =  response.data.project_tasks
                this.project_tasks_backup = [...this.project_tasks]
                this.items_counter = this.project_tasks.length
            } 
            else
            {
                this.error_handling(response)
            }
        },

        fill_data(data)
        {
            this.array_options = {
                floor_id:       data.floor_types,
                task_id:        data.daily_task,
                frequency_id:   data.frequencies,
            }

            let floors = this.array_options.floor_id
            let daily_tasks = this.array_options.task_id

            this.form_data.floor_id = floors.length ? floors[0].id : ''
            this.form_data.task_id = daily_tasks.length ? daily_tasks[0].id : ''
        },

        async form_submit()
        {

            let filterInSelected = this.project_tasks.filter(item => item.frequency_id === '' && item.checked === true)

            if(filterInSelected.length)
            {
                for(let i = 0; i < filterInSelected.length; i++)
                {
                    let item = filterInSelected[i]

                    let indexProject = this.project_tasks.findIndex(prop => prop.id === item.id)
                    
                    if(indexProject > -1)
                    {
                        window.$(`#selectFreq${indexProject}`).focus()
                        notyf.error('No frequency selected')
                        return false
                    }
                }
            }

            this.get_loader()
            
            let form_data = {
                relations:  this.form_data,
                projects:   this.project_tasks,
            }

            let response = await this.post(this.rest_api, form_data)

            if(response.status)
            {
                notyf.success('Success')
                this.hide_loader()
            } 
            else
            {
                this.error_handling(response)
            }
            this.hide_loader()
        },

    },

    async mounted() {
        if(this.hasPermissions(['Options-Defalut-Project-Codes Read']))
        {
            await this.api_request()
            await this.project_task_query()

        }
        
    }

}

export default localMethods